export default __webpack_public_path__ + "static/media/4.cdcac0c4.png";